"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RecordAuditListOperations", {
    enumerable: true,
    get: function() {
        return RecordAuditListOperations;
    }
});
const _common = require("@nestjs/common");
const _auditsservice = require("~/services/audits.service");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let RecordAuditListOperations = class RecordAuditListOperations {
    async handle(context, { req }) {
        return await this.auditsService.recordAuditList(context, {
            row_id: req.query.row_id,
            fk_model_id: req.query.fk_model_id,
            cursor: req.query.cursor
        });
    }
    constructor(auditsService){
        this.auditsService = auditsService;
        this.operations = [
            'recordAuditList'
        ];
        this.httpMethod = 'GET';
    }
};
RecordAuditListOperations = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _auditsservice.AuditsService === "undefined" ? Object : _auditsservice.AuditsService
    ])
], RecordAuditListOperations);
